import { combineReducers } from 'redux';
import localesReducer from './i18n'
import verifyDSInputReducer from './setVerifyDSInput'
import verifyDSOptionsReducer from './verifyDSOptionsReducer'
import createDSOptionsReducer from './createDSOptionsReducer'
import encryptOptionsReducer from './encryptOptionsReducer'
import certificateInfo from './certificateInfo'
import createDSInputReducer from './createDSInputReducer'
import createDSTextReducer from './createDSTextReducer'
import encryptReducer from './encryptReducer'
import decryptReducer from './decryptReducer'
import connectionStatusReucer from './connectionStatus'
import keyGeneratorReducer from './keyGeneratorReducer'
import verifyDSTextInputReducer from './verifyDSTextInputReducer'
import encryptTextReducer from './encryptTextReducer'
import decryptTextReducer from './decryptTextReducer'
import encryptFilesReducer from './encryptFilesReducer'
import createVerifyTSReducer from './createVerifyTSReducer'

const baseURLs = {
    urlsSetted: false,
    psDSUrl: "",
    agentForDS: "",
    version: "",
    build: "",
    verifyDS: false,
    createDs: false,
    decrypt: false,
    encrypt: false,
    keyGenerator: false,
    certInfoSignature: false,
    certInfoKeyAgreement: false,
    createVerifyTs: false,
    useRoutes: false,
    instance: "",
    serviceTitle: "clientForService"
}

const base = (state = baseURLs, { type, payload }) => {

    switch (type) {
        case 'SET_URLS': {
            return {
                ...state,
                psDSUrl: payload.psDSUrl,
                agentForDS: payload.agentForDS,
                urlsSetted: true
            }
        }

        case 'SET_CONFIG': {
            return {
                ...state,
                useRoutes: payload.useRoutes,
                instance: payload.instance,
                serviceTitle: payload.serviceTitle || "personalDsService"
            }
        }

        case 'SET_FEATURES': {
            return {
                ...state,
                verifyDS: payload.DS_VERIFY_OPT || false,
                createDs: payload.DS_CREATE_OPT || false,
                decrypt: payload.DECRYPT || false,
                encrypt: payload.ENCRYPT || false,
                keyGenerator: payload.KEYS_GENERATION_OPT || false,
                certInfoSignature: payload.CERT_SIGNATURE_INFO_OPT || false,
                certInfoKeyAgreement: payload.CERT_KEYAGREEMENT_INFO_OPT || false,
                createVerifyTs: payload.TS_CREATE_OPT || false
            }
        }

        case 'SET_VERSION': {
            return {
                ...state,
                version: payload.version,
                build: payload.build
            }
        }

        default:
            return state;
    }

}

export default combineReducers({
    base: base,
    localesReducer: localesReducer,
    connectionStatusReucer: connectionStatusReucer,
    verifyDSInputReducer: verifyDSInputReducer,
    verifyDSOptionsReducer: verifyDSOptionsReducer,
    createDSOptionsReducer: createDSOptionsReducer,
    encryptOptionsReducer: encryptOptionsReducer,
    certificateInfo: certificateInfo,
    createDSInputReducer: createDSInputReducer,
    createDSTextReducer: createDSTextReducer,
    encryptReducer: encryptReducer,
    decryptReducer: decryptReducer,
    keyGeneratorReducer: keyGeneratorReducer,
    verifyDSTextInputReducer: verifyDSTextInputReducer,
    encryptTextReducer: encryptTextReducer,
    decryptTextReducer: decryptTextReducer,
    encryptFilesReducer: encryptFilesReducer,
    createVerifyTSReducer: createVerifyTSReducer
});





// WEBPACK FOOTER //
// ./src/reducers/index.js